export function isDevForceLogoutEnabled(nodeEnv = process.env.NODE_ENV) {
  return nodeEnv !== 'production';
}

// Manual test (dev only): press Ctrl+Shift+L to force expiry logout.
export function registerDevForceLogoutShortcut(
  onForceLogout,
  { nodeEnv = process.env.NODE_ENV, target = typeof window !== 'undefined' ? window : null } = {}
) {
  if (!isDevForceLogoutEnabled(nodeEnv) || typeof onForceLogout !== 'function' || !target) {
    return () => {};
  }

  const handleKeydown = (event) => {
    const key = String(event?.key || '').toLowerCase();
    if (event?.ctrlKey && event?.shiftKey && key === 'l') {
      event.preventDefault();
      onForceLogout('expired');
    }
  };

  target.addEventListener('keydown', handleKeydown);
  return () => {
    target.removeEventListener('keydown', handleKeydown);
  };
}
